
<div class="rule-wrapper">
  <div class="row">
    <div class="col">
      <template v-for="(rule, i) in rules">
        <template v-if="isRule(rule)">
          <edit-conditional-rule :rule="rule"
                                 :rule-set="ruleSet"
                                 :isFirstRule="i === 0"
                                 :parent="parent"
                                 :key="rule.client_id"
                                 :index="i"
                                 v-bind="conditionalRuleOptions"
                                 :outside-modal="outsideModal"
                                 :matchFormFields="matchFormFields"
          >
            <template #rule-options="slotProps" ><slot name="rule-options" :rule="slotProps.rule"></slot></template>
          </edit-conditional-rule>
        </template>
        <template v-else>
          <div class="row">
            <div class="col-1 head">
              <template v-if="i === 0">
                <strong>If</strong>
              </template>
              <template v-else>
                <and-or-select v-model="ruleSet.join_type" :outside-modal="outsideModal"></and-or-select>
              </template>
            </div>
            <div class="col">
              <edit-conditional-rule-set :rule-set="rule"
                                         :isFirstRule="i === 0"
                                         :key="rule.client_id"
                                         :parent="parent"
                                         :conditional-rule-options="conditionalRuleOptions"
                                         :outside-modal="outsideModal"
                                         :match-form-fields="matchFormFields"
              >
                <template #rule-options="slotProps" ><slot name="rule-options" :rule="slotProps.rule"></slot></template>
              </edit-conditional-rule-set>
            </div>
          </div>
        </template>
      </template>
    </div>
    <div class="col-1 suffix" v-if="canControl && !disallowMultipleConditions">
      <rule-options :model="ruleSet"></rule-options>
    </div>
  </div>
  <div class="add-control" v-if="!disallowMultipleConditions">
    <div class="dropdown">
      <button data-toggle="dropdown"
              @click="teleport.dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="dropdown-toggle btn-icon grey-to-blue add-rule">
        <span class="sr-only">Add Rule Dropdown</span>
        <span class="icon-text plus"></span>
      </button>
      <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ruleSetMoreOptions">
        <li>
          <button class="dropdown-item" @click="addRule">+ Add Condition</button>
          <button v-if="allowMultipleSets" class="dropdown-item" @click="addRuleSet">+ Add AND/OR group</button>
        </li>
      </ul>
    </div>
  </div>
</div>
